<template>
  <div>
    <Form inline label-position="left" :label-width="120">
      <Row :gutter="10">
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('Application_No')"
            ><!-- 申请单号 -->
            <Input v-model="searchItem.applyNo"></Input>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="6">
          <FormItem :label="$t('userName')"
            ><!-- 申请单号 -->
            <Input v-model="searchItem.userName"></Input>
          </FormItem>
        </Col>
        <Col :xs="24" :sm="24" :md="12" :lg="1">
          <Button type="primary" @click="total=0,pageInfo.pageNo=1,getData()"
            ><!-- 检索 -->{{ $t("Search") }}</Button
          >
        </Col>
      </Row>
    </Form>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      @on-select-cancel="TableSelectCancelRow"
      @on-select-all-cancel="cancelAll"
      @on-select-all="selsetAll"
      @on-select="peoOnSelectRow"
      ref="selection"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="ios-create"
          size="small"
          @click="selectBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <div style="margin-top:10px;display:flex;justify-content: space-between;">
      <Page :total="total" @on-change="pageChange" />
      <div>
        <Button type="primary" @click="batchApproval"
          ><!-- 批量审批 -->{{ $t("Approve_All") }}</Button
        >
        <Button type="primary" @click="returnPage"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
    </div>
    <ApprovalRemark ref="ApprovalRemark" @ok="approvalOk"></ApprovalRemark>
  </div>
</template>
<script>
import axios from "axios";
import ApprovalRemark from "./ApprovalRemark.vue";
import DateUtil from "@/util/DateUtil";
export default {
  components: { ApprovalRemark },
  data() {
    return {
      date: new DateUtil(),
      searchItem: {},
      modalShow: false,
      loading: false,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      total: 0,
      selectList: [],
      data: [],
      ApplyStatus: [],
      UpdateStatus: [],
      businessUnit: []
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns() {
      return [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("SHOW_DETAILS") /* 审批 */,
          slot: "action",
          align: "center",
          minWidth: 70
        },
        {
          title: this.$t("Stage_Apply") /* 申请单类型 */,
          key: this.lang == "zh" ? "achStage" : "enAchStage",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Application_No") /* 申请单号 */,
          key: "applyNo",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Filing_date") /* 申请日期 */,
          key: "createTime",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.createTime, "YYYY-MM-DD")
            );
          }
        },
        {
          title: this.$t("Applicant") /* 申请人 */,
          key: "createUser",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Applicant_Business_Unit") /* 申请人业务单元 */,
          key: "applyBusinessUnit",
          align: "center",
          minWidth: 140,
          render: (h, params) => {
            return h(
              "span",
              this.businessUnit &&
                this.businessUnit
                  .filter(item => params.row.applyBusinessUnit == item.code)
                  .map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        },
        {
          title: this.$t("Current_Approver_Now") /* 当前审批人 */,
          key: "approvalName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Application_Status") /* 申请状态 */,
          key: "status",
          align: "center",
          minWidth: 120,
          render: (h, params) => {
            return h(
              "span",
              this.ApplyStatus &&
                this.ApplyStatus.filter(
                  item => params.row.status == item.code
                ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))
            );
          }
        }
      ];
    }
  },
  created() {
    this.getSelectList();
    this.getData();
  },
  methods: {
    getSelectList() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.ApplyStatus = res.ApplyStatus;
          this.UpdateStatus = res.UpdateStatus;
          this.businessUnit = res.businessUnitList;
        }
      });
    },
    getData() {
      this.loading = true;
      axios
        .post("/achReport/selectAgentApprovalList", {
          ...this.pageInfo,
          ...this.searchItem
        })
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = parseInt(res.pageInfo.total);
          }
        });
    },
    selectBtn(row, index) {
      this.$router.push({
        path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
        query: {
          id: row.id,
          serialnumber: row.serialnumber,
          beUpdateFlag: row.beUpdateFlag,
          achStage: row.achStage
        }
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    batchApproval() {
      if (this.selectList.length == 0) {
        this.$Message.info(this.$t("Emp_Ach_mess1"));
      } else {
        this.$refs.ApprovalRemark.modalShow = true;
      }
    },
    async approvalOk(value) {
      await this.selectList.forEach(el => {
        el.idea = value;
        el.isAgentFalg = "1";
      });
      this.loading = true;
      axios
        .post("/AchProcess/approvalAchProcessList", this.selectList)
        .then(res => {
          this.loading = false;
          if (res) {
            this.$Message.info(this.$t("Approval_Completed"));
            this.getData();
          }
        });
    },
    TableSelectCancelRow(selection, row) {
      this.selectList.forEach((el, index) => {
        if (el.id == row.id) {
          this.selectList.splice(index, 1);
        }
      });
    },
    peoOnSelectRow(selection, row) {
      if (!this.selectList.includes(row.id)) {
        this.selectList.push(row);
      }
    },
    selsetAll(selection) {
      this.data.forEach(el => {
        this.selectList.push(el);
      });
      let map = new Map();
      for (let item of this.selectList) {
        map.set(item.id, item);
      }
      this.selectList = [...map.values()];
    },
    cancelAll(selection) {
      this.data.forEach(row => {
        this.selectList.forEach((el, index) => {
          if (el.id == row.id) {
            this.selectList.splice(index, 1);
          }
        });
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/modalComponents/AgencyApprovalList.vue